<script setup>
import {defineProps, defineModel, defineEmits} from 'vue'

const modelValue = defineModel({required: false})

const emit = defineEmits(['change'])
const props = defineProps({
  id: {
    type: String,
    default: 'the-switcher',
  },
  label: {
    type: String,
    default: '',
  },
  trueValue: {default: true},
  falseValue: {default: false},
  disabled: {
    type: Boolean,
    default: false,
  },
})

// Methods

const onChange = () => {
  emit('change', modelValue.value)
}
</script>

<template>
  <div class="form-check form-switch gap-1">
    <input
      v-model="modelValue"
      class="form-check-input"
      type="checkbox"
      role="switch"
      :id="props.id"
      :true-value="props.trueValue"
      :false-value="props.falseValue"
      :disabled="disabled"
      @change="onChange()"
    />
    <label class="form-check-label" :for="props.id"><slot>{{ props.label }}</slot></label>
  </div>
</template>

<style lang="scss" scoped>
.form-switch {
  display: flex;
  align-items: center;
}

.form-switch .form-check-input {
  cursor: pointer;
  width: 40px !important;
}

.form-check-input {
  height: 24px;
  border: 1px solid #d1d5db;
  padding: 3px;
  background-image: url('~@shared-images/icons/inputs/switcher-circle.svg');
  background-size: 16px;
  background-position: 3px 3px;
  margin-top: 0;

  &:checked {
    border-color: #eb704b;
    background-image: url('~@shared-images/icons/inputs/switcher-circle-checked.svg');
    background-size: 16px;
    background-position: calc(100% - 3px) 3px;
  }
}

.form-check-label {
  margin: 0 !important;
}
</style>
